import { UserDeleteUseCase } from '../../../../application';

export default class UserDeleteService {

    async RequestData(event) {
        const data = await UserDeleteUseCase(event);
        return data;
    }
}
